import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceIcon = ({ id })=>/*#__PURE__*/ _jsxs("svg", {
        width: "141",
        height: "141",
        viewBox: "0 0 141 141",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M34.5807 32.3299C24.4329 36.6045 19.4847 47.3001 24.0827 58.2202C30.0277 72.3373 56.1874 80.3532 57.4177 80.5328C58.5223 80.7034 59.8155 80.0658 59.8155 78.8445C59.8155 77.6231 57.4177 67.479 57.4177 66.7606C57.4177 66.0421 57.8219 65.3955 58.5133 65.1082C59.2048 64.8208 89.5405 51.9609 99.5985 47.7312C109.656 43.5014 114.425 32.1143 110.097 21.8408C105.768 11.5673 94.318 7.0861 84.2061 11.3428C74.0943 15.5995 44.7285 28.0642 34.5807 32.3299Z",
                fill: "#FF4D77"
            }),
            /*#__PURE__*/ _jsx("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M104.86 109.543C115.007 105.268 119.956 94.5725 115.358 83.6524C109.413 69.5353 83.2528 61.5716 82.0225 61.392C80.918 61.2213 79.6248 61.859 79.6248 63.0803C79.6248 64.3016 82.0225 74.3937 82.0225 75.1121C82.0225 75.8305 81.6184 76.4771 80.9269 76.7645C80.2354 77.0518 49.8998 89.9117 39.8418 94.1415C29.7838 98.3712 25.0152 109.758 29.3438 120.032C33.6723 130.314 45.1222 134.787 55.2341 130.53C65.355 126.273 94.7118 113.808 104.86 109.543Z",
                fill: "url(#paint0_linear_5103_21897)"
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_5103_21897",
                    x1: "88.7956",
                    y1: "136.503",
                    x2: "86.7448",
                    y2: "63.5146",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            "stop-color": "#FF4D77"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.47",
                            "stop-color": "#FF4D77",
                            "stop-opacity": "0.85"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            "stop-color": "#FF4D77",
                            "stop-opacity": "0.4"
                        })
                    ]
                })
            })
        ]
    });
